import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { IBlockInstanceModel } from 'models/block.model'
import BlockListItem from './components/BlockListItem'
import styles from './BlockList.module.scss'

interface IBlockList {
  active: number | undefined
  blocks: IBlockInstanceModel[]
  onDelete: any
  onEdit: any
  onOrderChange: any
  draggable: boolean
  highlightBlockId?: number | null
}

const BlockList: React.FC<IBlockList> = ({
  active,
  blocks,
  draggable,
  onDelete,
  onEdit,
  onOrderChange,
  highlightBlockId,
}) => {
  const { t } = useTranslation()
  const [blocksState, setBlocks] = useState([] as any)

  useEffect(() => {
    setBlocks(blocks)
  }, [blocks])

  const [dragging, setDraggingItem] = useState(undefined as any)
  const handleDragStart = (e: any, from: number) => {
    setDraggingItem(from)
    e.dataTransfer.effectAllowed = 'move'
    e.dataTransfer.setData('text/html', null)
  }

  const handleDragOver = (e: any, to: number) => {
    e.preventDefault()
    const currentList = blocksState
    const from = isFinite(dragging) ? dragging : 0
    currentList.splice(to, 0, currentList.splice(from, 1)[0])
    sort(currentList, to)
  }

  const sort = (list: any, dragging: any) => {
    setDraggingItem(dragging)
    setBlocks(list)
    onOrderChange(list)
  }

  return (
    <div className={`my-3 ${styles.blockList}`}>
      {blocksState && blocksState.length > 0 ? (
        blocksState.map((block: IBlockInstanceModel, index: number) => {
          const {
            id,
            name,
            blockType,
            hasResponses,
            containFiles,
            isValidated,
            processed,
          } = block

          return (
            <div
              key={`${id}-${index}`}
              id={`block-instance-${id}`}
              className={`${styles.blockItem} ${
                active === id ? styles.blockActive : ''
              } ${highlightBlockId === id ? styles.blockHighlight : ''}`}
              draggable={draggable}
              onDragStart={(e: any) => handleDragStart(e, index)}
              onDragOver={(e: any) => handleDragOver(e, index)}
            >
              <BlockListItem
                id={id}
                name={`${index + 1}. ${name}`}
                onEdit={() => onEdit(block)}
                onDelete={onDelete}
                dragDrop={draggable}
                type={blockType}
                isValidated={isValidated}
                processed={processed}
                destroyable={!containFiles}
                disabled={active === id}
                block={block}
                hasResponses={hasResponses}
              />
            </div>
          )
        })
      ) : (
        <div>{t('administration.blocks.withoutBlocks')}</div>
      )}
    </div>
  )
}

export default BlockList
